import React from "react";
import { View, Text, TouchableOpacity, Dimensions } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import Colors from "@microdoing/shared/constants/Colors";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import theme from "app/Theme/Theme";

const { width } = Dimensions.get("window");

const Header = ({ title, navigation, picture, navigateProfile, testID }) => {
  const onPressBack = () => {
    navigation.goBack();
  };

  return (
    <View style={styles.main}>
      <View style={styles.leftView}>
        <TouchableOpacity
          testID={testID}
          style={styles.backIcon}
          onPress={onPressBack}
          hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
        >
          <Icon
            name="arrow-left"
            size={25}
            color={theme.colors["neutral.900"]}
          />
        </TouchableOpacity>
      </View>
      <View onPress={navigateProfile} style={styles.middleView}>
        <Text style={styles.text}>{title}</Text>
      </View>
      <View style={styles.rightView} />
    </View>
  );
};

Header.defaultProps = {
  title: "Mes Amis",
};

const styles = {
  main: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: 50,
    width,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors["neutral.100"],
  },
  leftView: {
    alignItems: "flex-start",
    justifyContent: "center",
    flex: 1,
  },
  backIcon: {
    marginLeft: 25,
  },
  picture: {
    marginRight: 10,
    height: 35,
    width: 35,
    borderRadius: 17.5,
  },
  middleView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flex: 4,
  },
  rightView: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  settings: {
    marginRight: 5,
  },
  search: {
    marginRight: 15,
  },
  text: {
    color: theme.colors["neutral.900"],
    fontWeight: "bold",
    fontSize: wp("5%"),
  },
};

export default Header;
